// Effect Managers
import { put, call, fork } from 'redux-saga/effects'

// Exports
export default function composeRead ({
  state,
  actionCreators,
  handler,
}) {
  const read = function *read (
    { url, queryParams, id, requestId } = {},
    { block = true, meta = {} } = {}
  ) {
    if (!block && state.get().watch.read) {
      const action = actionCreators.fetch({
        url, queryParams, id,
      }, {
        meta,
      })

      yield put(action)
    } else {
      const result = yield call(handler, { url, queryParams, id }, { requestId, meta })
      return result
    }
  }

  const readNonBlocking = function *readNonBlocking (
    payload = {},
    { meta = {} } = {}
  ) {
    yield fork(read, payload, {
      block: false,
      meta,
    })
  }

  return {
    read,
    readNonBlocking,
  }
}
